import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function GoodBed(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#F1F5FB" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <g clipPath="url(#clip0_10225_142972)">
        <path
          d="M19.0076 13.9929C16.625 14.0172 13.8008 14.0229 12.0614 14.0229H11.9384C10.199 14.0229 7.37478 14.0172 4.99219 13.9929C5.02792 12.6165 5.05079 12.6208 5.1394 12.2206C5.188 11.9962 5.29948 11.8433 5.44955 11.6703L7.29903 9.55073C7.41337 9.41924 7.58489 9.35063 7.75926 9.36635L9.00987 9.48069C10.0046 9.57074 11.0023 9.61504 11.9999 9.61362C12.9975 9.61504 13.9952 9.57074 14.9899 9.48069L16.2406 9.36635C16.4149 9.35063 16.5864 9.41924 16.7008 9.55073L18.5503 11.6703C18.7003 11.8433 18.8118 11.9962 18.8604 12.2206C18.949 12.6208 18.9719 12.6165 19.0076 13.9929V13.9929Z"
          fill="#9CC155"
        />
        <path
          d="M19.0076 14.5104V18.498C19.0076 18.6381 18.8947 18.751 18.7546 18.751H17.1539C17.0138 18.751 16.9009 18.6381 16.9009 18.498V16.0826H15.9804V16.6872C15.9804 16.8272 15.8675 16.9401 15.7274 16.9401H14.1067C13.9666 16.9401 13.8537 16.8272 13.8537 16.6872V16.1312H10.1519V16.6872C10.1519 16.8272 10.0389 16.9401 9.89888 16.9401H8.27808C8.13801 16.9401 8.0251 16.8272 8.0251 16.6872V16.0826H7.10465V18.498C7.10465 18.6381 6.99174 18.751 6.85167 18.751H5.24517C5.1051 18.751 4.99219 18.6381 4.99219 18.498V14.5104H19.0076V14.5104Z"
          fill="#639ED6"
        />
        <path
          d="M15.6147 5.43452H14.4956C14.2726 5.43452 14.0725 5.47597 13.9482 5.58745C13.8567 5.67035 13.8024 5.76897 13.8024 5.76897C13.5651 5.22298 13.0292 5.00573 12.2345 5.00573L12.1402 5.00288C12.0473 5.00002 11.9544 5.00002 11.86 5.00288L11.7657 5.00573C10.971 5.00573 10.435 5.22298 10.1978 5.76897C10.1978 5.76897 10.1435 5.67035 10.052 5.58745C9.92764 5.47597 9.72755 5.43452 9.50458 5.43452H8.38546C8.18393 5.43452 8.021 5.59745 8.021 5.79898V8.8176C8.021 8.90764 8.0896 8.98197 8.17965 8.98911C8.72706 9.03199 10.5823 9.16634 11.9243 9.16634H12.0758C13.4179 9.16634 15.2731 9.03199 15.8205 8.98911C15.9106 8.98197 15.9792 8.90764 15.9792 8.8176V5.79898C15.9792 5.59745 15.8162 5.43452 15.6147 5.43452V5.43452ZM13.0949 6.87379L12.5032 7.31401L12.7562 8.0901C12.7833 8.17157 12.6876 8.24018 12.6175 8.18872L11.9758 7.70849L11.3355 8.18443C11.2654 8.23589 11.1697 8.16585 11.1983 8.08296L11.4613 7.32258L10.861 6.87379C10.7924 6.82234 10.8281 6.71371 10.9138 6.71371H11.6728L11.9129 6.01909C11.9415 5.93905 12.0558 5.93905 12.0816 6.02052L12.3074 6.71371H13.042C13.1278 6.71371 13.1635 6.82234 13.0949 6.87379V6.87379Z"
          fill="#639ED6"
        />
      </g>
      <defs>
        <clipPath id="clip0_10225_142972">
          <rect fill="white" height="13.751" transform="translate(4.99219 5)" width="14.0154" />
        </clipPath>
      </defs>
    </svg>
  );
}

GoodBed.propTypes = propTypes;
GoodBed.defaultProps = defaultProps;

export default GoodBed;
